const product_card = [
    {
        id: 1,
        product_name: "Name OF The Product With alot of words",
        description: "Description",
        price: 100,
        currency: "LE",
        category: "Men",
        path:"menbottoms",
        classify: "Bottoms",
        colors:["red","black","crimson","teal"],
        "src": [
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/qwqfyddzikcgc4ozwigp/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/fxufamcpmcnz20lj31no/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/c90ymoqfystuna165ipq/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/dq9ivyxncfxo3gzkmlkl/revolution-5-road-running-shoes-szF7CS.png"
        ],
        content: "Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product",
        thumb:"https://cdn.shopify.com/s/files/1/0845/0641/products/Pants27_540x.jpg?v=1653747533"
    },
    {
        id: 2,
        product_name: "Name OF The Product",
        description: "Description",
        price: 100,
        currency: "LE",
        category: "Men",
        path:"menbottoms",
        classify: "Bottoms",
        colors:["red","black","crimson","teal"],
        "src": [
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/qwqfyddzikcgc4ozwigp/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/fxufamcpmcnz20lj31no/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/c90ymoqfystuna165ipq/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/dq9ivyxncfxo3gzkmlkl/revolution-5-road-running-shoes-szF7CS.png"
        ],
        content: "Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product",
        thumb:"https://cdn.shopify.com/s/files/1/0845/0641/products/Pants27_540x.jpg?v=1653747533"
    },
    {
        id: 3,
        product_name: "Name OF The Product",
        description: "Description",
        price: 100,
        currency: "LE",
        category: "Men",
        path:"menbottoms",
        classify: "Bottoms",
        colors:["red","black","crimson","teal"],
        "src": [
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/qwqfyddzikcgc4ozwigp/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/fxufamcpmcnz20lj31no/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/c90ymoqfystuna165ipq/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/dq9ivyxncfxo3gzkmlkl/revolution-5-road-running-shoes-szF7CS.png"
        ],
        content: "Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product",
        thumb:"https://cdn.shopify.com/s/files/1/0845/0641/products/Pants27_540x.jpg?v=1653747533"
    },
    {
        id: 4,
        product_name: "Name OF The Product",
        description: "Description",
        price: 100,
        currency: "LE",
        category: "Men",
        path:"menbottoms",
        classify: "Bottoms",
        colors:["red","black","crimson","teal"],
        "src": [
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/qwqfyddzikcgc4ozwigp/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/fxufamcpmcnz20lj31no/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/c90ymoqfystuna165ipq/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/dq9ivyxncfxo3gzkmlkl/revolution-5-road-running-shoes-szF7CS.png"
        ],
        content: "Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product",
        thumb:"https://cdn.shopify.com/s/files/1/0845/0641/products/Pants27_540x.jpg?v=1653747533"
    },
    {
        id: 5,
        product_name: "Name OF The Product",
        description: "Description",
        price: 100,
        currency: "LE",
        category: "Men",
        path:"menbottoms",
        classify: "Bottoms",
        colors:["red","black","crimson","teal"],
        "src": [
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/qwqfyddzikcgc4ozwigp/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/fxufamcpmcnz20lj31no/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/c90ymoqfystuna165ipq/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/dq9ivyxncfxo3gzkmlkl/revolution-5-road-running-shoes-szF7CS.png"
        ],
        content: "Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product",
        thumb:"https://cdn.shopify.com/s/files/1/0845/0641/products/Pants27_540x.jpg?v=1653747533"
    },
    {
        id: 6,
        product_name: "Name OF The Product",
        description: "Description",
        price: 100,
        currency: "LE",
        category: "Men",
        path:"menbottoms",
        classify: "Bottoms",
        colors:["red","black","crimson","teal"],
        "src": [
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/qwqfyddzikcgc4ozwigp/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/fxufamcpmcnz20lj31no/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/c90ymoqfystuna165ipq/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/dq9ivyxncfxo3gzkmlkl/revolution-5-road-running-shoes-szF7CS.png"
        ],
        content: "Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product",
        thumb:"https://cdn.shopify.com/s/files/1/0845/0641/products/Pants27_540x.jpg?v=1653747533"
    },
    {
        id: 7,
        product_name: "Name OF The Product",
        description: "Description",
        price: 100,
        currency: "LE",
        category: "Men",
        path:"menbottoms",
        classify: "Bottoms",
        colors:["red","black","crimson","teal"],
        "src": [
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/qwqfyddzikcgc4ozwigp/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/fxufamcpmcnz20lj31no/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/c90ymoqfystuna165ipq/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/dq9ivyxncfxo3gzkmlkl/revolution-5-road-running-shoes-szF7CS.png"
        ],
        content: "Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product",
        thumb:"https://cdn.shopify.com/s/files/1/0845/0641/products/Pants27_540x.jpg?v=1653747533"
    },
    {
        id: 8,
        product_name: "Name OF The Product",
        description: "Description",
        price: 100,
        currency: "LE",
        category: "Men",
        path:"menbottoms",
        classify: "Bottoms",
        colors:["red","black","crimson","teal"],
        "src": [
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/qwqfyddzikcgc4ozwigp/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/fxufamcpmcnz20lj31no/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/c90ymoqfystuna165ipq/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/dq9ivyxncfxo3gzkmlkl/revolution-5-road-running-shoes-szF7CS.png"
        ],
        content: "Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product",
        thumb:"https://cdn.shopify.com/s/files/1/0845/0641/products/Pants27_540x.jpg?v=1653747533"
    },
    {
        id: 9,
        product_name: "Name OF The Product",
        description: "Description",
        price: 100,
        currency: "LE",
        category: "Men",
        path:"menbottoms",
        classify: "Bottoms",
        colors:["red","black","crimson","teal"],
        "src": [
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/qwqfyddzikcgc4ozwigp/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/fxufamcpmcnz20lj31no/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/c90ymoqfystuna165ipq/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/dq9ivyxncfxo3gzkmlkl/revolution-5-road-running-shoes-szF7CS.png"
        ],
        content: "Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product",
        thumb:"https://cdn.shopify.com/s/files/1/0845/0641/products/Pants27_540x.jpg?v=1653747533"
    },
    {
        id: 10,
        product_name: "Name OF The Product",
        description: "Description",
        price: 100,
        currency: "LE",
        category: "Men",
        path:"menbottoms",
        classify: "Bottoms",
        colors:["red","black","crimson","teal"],
        "src": [
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/qwqfyddzikcgc4ozwigp/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/fxufamcpmcnz20lj31no/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/c90ymoqfystuna165ipq/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/dq9ivyxncfxo3gzkmlkl/revolution-5-road-running-shoes-szF7CS.png"
        ],
        content: "Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product",
        thumb:"https://cdn.shopify.com/s/files/1/0845/0641/products/Pants27_540x.jpg?v=1653747533"
    },
    {
        id: 11,
        product_name: "Name OF The Product",
        description: "Description",
        price: 100,
        currency: "LE",
        category: "Men",
        path:"menbottoms",
        classify: "Bottoms",
        colors:["red","black","crimson","teal"],
        "src": [
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/qwqfyddzikcgc4ozwigp/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/fxufamcpmcnz20lj31no/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/c90ymoqfystuna165ipq/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/dq9ivyxncfxo3gzkmlkl/revolution-5-road-running-shoes-szF7CS.png"
        ],
        content: "Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product",
        thumb:"https://cdn.shopify.com/s/files/1/0845/0641/products/Pants27_540x.jpg?v=1653747533"
    },
    {
        id: 12,
        product_name: "Name OF The Product",
        description: "Description",
        price: 100,
        currency: "LE",
        category: "Men",
        path:"menbottoms",
        classify: "Bottoms",
        colors:["red","black","crimson","teal"],
        "src": [
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/qwqfyddzikcgc4ozwigp/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/fxufamcpmcnz20lj31no/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/c90ymoqfystuna165ipq/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/dq9ivyxncfxo3gzkmlkl/revolution-5-road-running-shoes-szF7CS.png"
        ],
        content: "Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product",
        thumb:"https://cdn.shopify.com/s/files/1/0845/0641/products/Pants27_540x.jpg?v=1653747533"
    },
    {
        id: 13,
        product_name: "Name OF The Product",
        description: "Description",
        price: 100,
        currency: "LE",
        category: "Men",
        path:"menbottoms",
        classify: "Bottoms",
        colors:["red","black","crimson","teal"],
        "src": [
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/qwqfyddzikcgc4ozwigp/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/fxufamcpmcnz20lj31no/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/c90ymoqfystuna165ipq/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/dq9ivyxncfxo3gzkmlkl/revolution-5-road-running-shoes-szF7CS.png"
        ],
        content: "Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product",
        thumb:"https://cdn.shopify.com/s/files/1/0845/0641/products/Pants27_540x.jpg?v=1653747533"
    },
    {
        id: 14,
        product_name: "Name OF The Product",
        description: "Description",
        price: 100,
        currency: "LE",
        category: "Men",
        path:"menbottoms",
        classify: "Bottoms",
        colors:["red","black","crimson","teal"],
        "src": [
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/qwqfyddzikcgc4ozwigp/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/fxufamcpmcnz20lj31no/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/c90ymoqfystuna165ipq/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/dq9ivyxncfxo3gzkmlkl/revolution-5-road-running-shoes-szF7CS.png"
        ],
        content: "Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product",
        thumb:"https://cdn.shopify.com/s/files/1/0845/0641/products/Pants27_540x.jpg?v=1653747533"
    },
    {
        id: 15,
        product_name: "Name OF The Product",
        description: "Description",
        price: 100,
        currency: "LE",
        category: "Men",
        path:"menbottoms",
        classify: "Bottoms",
        colors:["red","black","crimson","teal"],
        "src": [
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/qwqfyddzikcgc4ozwigp/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/fxufamcpmcnz20lj31no/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/c90ymoqfystuna165ipq/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/dq9ivyxncfxo3gzkmlkl/revolution-5-road-running-shoes-szF7CS.png"
        ],
        content: "Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product",
        thumb:"https://cdn.shopify.com/s/files/1/0845/0641/products/Pants27_540x.jpg?v=1653747533"
    },
    {
        id: 16,
        product_name: "Name OF The Product",
        description: "Description",
        price: 100,
        currency: "LE",
        category: "Men",
        path:"menbottoms",
        classify: "Bottoms",
        colors:["red","black","crimson","teal"],
        "src": [
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/qwqfyddzikcgc4ozwigp/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/fxufamcpmcnz20lj31no/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/c90ymoqfystuna165ipq/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/dq9ivyxncfxo3gzkmlkl/revolution-5-road-running-shoes-szF7CS.png"
        ],
        content: "Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product",
        thumb:"https://cdn.shopify.com/s/files/1/0845/0641/products/Pants27_540x.jpg?v=1653747533"
    },
    {
        id: 17,
        product_name: "Name OF The Product",
        description: "Description",
        price: 100,
        currency: "LE",
        category: "Men",
        path:"menbottoms",
        classify: "Bottoms",
        colors:["red","black","crimson","teal"],
        "src": [
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/qwqfyddzikcgc4ozwigp/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/fxufamcpmcnz20lj31no/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/c90ymoqfystuna165ipq/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/dq9ivyxncfxo3gzkmlkl/revolution-5-road-running-shoes-szF7CS.png"
        ],
        content: "Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product",
        thumb:"https://cdn.shopify.com/s/files/1/0845/0641/products/Pants27_540x.jpg?v=1653747533"
    },
    {
        id: 18,
        product_name: "Name OF The Product",
        description: "Description",
        price: 100,
        currency: "LE",
        category: "Men",
        path:"menbottoms",
        classify: "Bottoms",
        colors:["red","black","crimson","teal"],
        "src": [
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/qwqfyddzikcgc4ozwigp/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/fxufamcpmcnz20lj31no/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/c90ymoqfystuna165ipq/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/dq9ivyxncfxo3gzkmlkl/revolution-5-road-running-shoes-szF7CS.png"
        ],
        content: "Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product",
        thumb:"https://cdn.shopify.com/s/files/1/0845/0641/products/Pants27_540x.jpg?v=1653747533"
    },
    {
        id: 19,
        product_name: "Name OF The Product With alot of words",
        description: "Description",
        price: 100,
        currency: "LE",
        category: "Women",
        path:"womentops",
        classify: "Tops",
        colors:["red","black","crimson","teal"],
        "src": [
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/qwqfyddzikcgc4ozwigp/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/fxufamcpmcnz20lj31no/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/c90ymoqfystuna165ipq/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/dq9ivyxncfxo3gzkmlkl/revolution-5-road-running-shoes-szF7CS.png"
        ],
        content: "Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product",
        thumb:"https://cdn.shopify.com/s/files/1/0845/0641/products/Pants27_540x.jpg?v=1653747533"
    },
    {
        id: 20,
        product_name: "Name OF The Product",
        description: "Description",
        price: 100,
        currency: "LE",
        category: "Women",
        path:"womentops",
        classify: "Tops",
        colors:["red","black","crimson","teal"],
        "src": [
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/qwqfyddzikcgc4ozwigp/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/fxufamcpmcnz20lj31no/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/c90ymoqfystuna165ipq/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/dq9ivyxncfxo3gzkmlkl/revolution-5-road-running-shoes-szF7CS.png"
        ],
        content: "Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product",
        thumb:"https://cdn.shopify.com/s/files/1/0845/0641/products/Pants27_540x.jpg?v=1653747533"
    },
    {
        id: 21,
        product_name: "Name OF The Product",
        description: "Description",
        price: 100,
        currency: "LE",
        category: "Women",
        path:"womentops",
        classify: "Tops",
        colors:["red","black","crimson","teal"],
        "src": [
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/qwqfyddzikcgc4ozwigp/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/fxufamcpmcnz20lj31no/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/c90ymoqfystuna165ipq/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/dq9ivyxncfxo3gzkmlkl/revolution-5-road-running-shoes-szF7CS.png"
        ],
        content: "Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product",
        thumb:"https://cdn.shopify.com/s/files/1/0845/0641/products/Pants27_540x.jpg?v=1653747533"
    },
    {
        id: 22,
        product_name: "Name OF The Product",
        description: "Description",
        price: 100,
        currency: "LE",
        category: "Women",
        path:"womentops",
        classify: "Tops",
        colors:["red","black","crimson","teal"],
        "src": [
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/qwqfyddzikcgc4ozwigp/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/fxufamcpmcnz20lj31no/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/c90ymoqfystuna165ipq/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/dq9ivyxncfxo3gzkmlkl/revolution-5-road-running-shoes-szF7CS.png"
        ],
        content: "Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product",
        thumb:"https://cdn.shopify.com/s/files/1/0845/0641/products/Pants27_540x.jpg?v=1653747533"
    },
    {
        id: 23,
        product_name: "Name OF The Product",
        description: "Description",
        price: 100,
        currency: "LE",
        category: "Women",
        path:"womentops",
        classify: "Tops",
        colors:["red","black","crimson","teal"],
        "src": [
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/qwqfyddzikcgc4ozwigp/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/fxufamcpmcnz20lj31no/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/c90ymoqfystuna165ipq/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/dq9ivyxncfxo3gzkmlkl/revolution-5-road-running-shoes-szF7CS.png"
        ],
        content: "Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product",
        thumb:"https://cdn.shopify.com/s/files/1/0845/0641/products/Pants27_540x.jpg?v=1653747533"
    },
    {
        id: 24,
        product_name: "Name OF The Product",
        description: "Description",
        price: 100,
        currency: "LE",
        category: "Women",
        path:"womentops",
        classify: "Tops",
        colors:["red","black","crimson","teal"],
        "src": [
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/qwqfyddzikcgc4ozwigp/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/fxufamcpmcnz20lj31no/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/c90ymoqfystuna165ipq/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/dq9ivyxncfxo3gzkmlkl/revolution-5-road-running-shoes-szF7CS.png"
        ],
        content: "Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product",
        thumb:"https://cdn.shopify.com/s/files/1/0845/0641/products/Pants27_540x.jpg?v=1653747533"
    },
    {
        id: 25,
        product_name: "Name OF The Product With alot of words",
        description: "Description",
        price: 100,
        currency: "LE",
        category: "Kids",
        path:"kidsgraphics",
        classify: "Graphics",
        colors:["red","black","crimson","teal"],
        "src": [
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/qwqfyddzikcgc4ozwigp/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/fxufamcpmcnz20lj31no/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/c90ymoqfystuna165ipq/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/dq9ivyxncfxo3gzkmlkl/revolution-5-road-running-shoes-szF7CS.png"
        ],
        content: "Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product",
        thumb:"https://cdn.shopify.com/s/files/1/0845/0641/products/Pants27_540x.jpg?v=1653747533"
    },
    {
        id: 26,
        product_name: "Name OF The Product",
        description: "Description",
        price: 100,
        currency: "LE",
        category: "Kids",
        path:"kidsgraphics",
        classify: "Graphics",
        colors:["red","black","crimson","teal"],
        "src": [
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/qwqfyddzikcgc4ozwigp/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/fxufamcpmcnz20lj31no/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/c90ymoqfystuna165ipq/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/dq9ivyxncfxo3gzkmlkl/revolution-5-road-running-shoes-szF7CS.png"
        ],
        content: "Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product",
        thumb:"https://cdn.shopify.com/s/files/1/0845/0641/products/Pants27_540x.jpg?v=1653747533"
    },
    {
        id: 27,
        product_name: "Name OF The Product",
        description: "Description",
        price: 100,
        currency: "LE",
        category: "Kids",
        path:"kidsgraphics",
        classify: "Graphics",
        colors:["red","black","crimson","teal"],
        "src": [
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/qwqfyddzikcgc4ozwigp/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/fxufamcpmcnz20lj31no/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/c90ymoqfystuna165ipq/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/dq9ivyxncfxo3gzkmlkl/revolution-5-road-running-shoes-szF7CS.png"
        ],
        content: "Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product",
        thumb:"https://cdn.shopify.com/s/files/1/0845/0641/products/Pants27_540x.jpg?v=1653747533"
    },
    {
        id: 28,
        product_name: "Name OF The Product",
        description: "Description",
        price: 100,
        currency: "LE",
        category: "Kids",
        path:"kidsgraphics",
        classify: "Graphics",
        colors:["red","black","crimson","teal"],
        "src": [
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/qwqfyddzikcgc4ozwigp/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/fxufamcpmcnz20lj31no/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/c90ymoqfystuna165ipq/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/dq9ivyxncfxo3gzkmlkl/revolution-5-road-running-shoes-szF7CS.png"
        ],
        content: "Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product",
        thumb:"https://cdn.shopify.com/s/files/1/0845/0641/products/Pants27_540x.jpg?v=1653747533"
    },
    {
        id: 29,
        product_name: "Name OF The Product",
        description: "Description",
        price: 100,
        currency: "LE",
        category: "Kids",
        path:"kidszippers",
        classify: "Zippers",
        colors:["red","black","crimson","teal"],
        "src": [
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/qwqfyddzikcgc4ozwigp/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/fxufamcpmcnz20lj31no/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/c90ymoqfystuna165ipq/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/dq9ivyxncfxo3gzkmlkl/revolution-5-road-running-shoes-szF7CS.png"
        ],
        content: "Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product",
        thumb:"https://cdn.shopify.com/s/files/1/0845/0641/products/Pants27_540x.jpg?v=1653747533"
    },
    {
        id: 30,
        product_name: "Name OF The Product With alot of words",
        description: "Description",
        price: 100,
        currency: "LE",
        category: "Accessories",
        colors:["red","black","crimson","teal"],
        "src": [
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/qwqfyddzikcgc4ozwigp/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/fxufamcpmcnz20lj31no/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/c90ymoqfystuna165ipq/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/dq9ivyxncfxo3gzkmlkl/revolution-5-road-running-shoes-szF7CS.png"
        ],
        content: "Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product",
        thumb:"https://cdn.shopify.com/s/files/1/0845/0641/products/Pants27_540x.jpg?v=1653747533"
    },
    {
        id: 31,
        product_name: "Name OF The Product",
        description: "Description",
        price: 100,
        currency: "LE",
        category: "Accessories",
        colors:["red","black","crimson","teal"],
        "src": [
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/qwqfyddzikcgc4ozwigp/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/fxufamcpmcnz20lj31no/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/c90ymoqfystuna165ipq/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/dq9ivyxncfxo3gzkmlkl/revolution-5-road-running-shoes-szF7CS.png"
        ],
        content: "Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product",
        thumb:"https://cdn.shopify.com/s/files/1/0845/0641/products/Pants27_540x.jpg?v=1653747533"
    },
    {
        id: 32,
        product_name: "Name OF The Product",
        description: "Description",
        price: 100,
        currency: "LE",   
        category: "Accessories",
        colors:["red","black","crimson","teal"],
        "src": [
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/qwqfyddzikcgc4ozwigp/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/fxufamcpmcnz20lj31no/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/c90ymoqfystuna165ipq/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/dq9ivyxncfxo3gzkmlkl/revolution-5-road-running-shoes-szF7CS.png"
        ],
        content: "Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product",
        thumb:"https://cdn.shopify.com/s/files/1/0845/0641/products/Pants27_540x.jpg?v=1653747533"
    },
    {
        id: 33,
        product_name: "Name OF The Product With alot of words",
        description: "Description",
        price: 100,
        currency: "LE",
        discount:'-25%',
        category: "Men",
        subCat:"Discount",
        classify:"Bottoms",
        colors:["red","black","crimson","teal"],
        "src": [
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/qwqfyddzikcgc4ozwigp/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/fxufamcpmcnz20lj31no/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/c90ymoqfystuna165ipq/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/dq9ivyxncfxo3gzkmlkl/revolution-5-road-running-shoes-szF7CS.png"
        ],
        content: "Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product",
        thumb:"https://cdn.shopify.com/s/files/1/0845/0641/products/Pants27_540x.jpg?v=1653747533"
    },
    {
        id: 34,
        product_name: "Name OF The Product",
        description: "Description",
        price: 100,
        currency: "LE",
        discount:'-25%',
        category: "Men",
        subCat:"Discount",
        classify:"Bottoms",
        colors:["red","black","crimson","teal"],
        "src": [
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/qwqfyddzikcgc4ozwigp/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/fxufamcpmcnz20lj31no/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/c90ymoqfystuna165ipq/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/dq9ivyxncfxo3gzkmlkl/revolution-5-road-running-shoes-szF7CS.png"
        ],
        content: "Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product",
        thumb:"https://cdn.shopify.com/s/files/1/0845/0641/products/Pants27_540x.jpg?v=1653747533"
    },
    {
        id: 35,
        product_name: "Name OF The Product",
        description: "Description",
        price: 100,
        currency: "LE",
        discount:'-25%',
        category: "Men",
        subCat:"Discount",
        classify:"Bottoms",
        colors:["red","black","crimson","teal"],
        "src": [
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/qwqfyddzikcgc4ozwigp/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/fxufamcpmcnz20lj31no/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/c90ymoqfystuna165ipq/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/dq9ivyxncfxo3gzkmlkl/revolution-5-road-running-shoes-szF7CS.png"
        ],
        content: "Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product",
        thumb:"https://cdn.shopify.com/s/files/1/0845/0641/products/Pants27_540x.jpg?v=1653747533"
    },
    {
        id: 36,
        product_name: "Name OF The Product",
        description: "Description",
        price: 100,
        currency: "LE",
        discount:'-25%',
        category: "Men",
        subCat:"Discount",
        classify:"Bottoms",
        colors:["red","black","crimson","teal"],
        "src": [
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/qwqfyddzikcgc4ozwigp/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/fxufamcpmcnz20lj31no/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/c90ymoqfystuna165ipq/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/dq9ivyxncfxo3gzkmlkl/revolution-5-road-running-shoes-szF7CS.png"
        ],
        content: "Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product",
        thumb:"https://cdn.shopify.com/s/files/1/0845/0641/products/Pants27_540x.jpg?v=1653747533"
    },
    {
        id: 37,
        product_name: "Name OF The Product",
        description: "Description",
        price: 100,
        currency: "LE",
        discount:'-25%',
        category: "Men",
        subCat:"Discount",
        classify:"Bottoms",
        colors:["red","black","crimson","teal"],
        "src": [
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/qwqfyddzikcgc4ozwigp/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/fxufamcpmcnz20lj31no/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/c90ymoqfystuna165ipq/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/dq9ivyxncfxo3gzkmlkl/revolution-5-road-running-shoes-szF7CS.png"
        ],
        content: "Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product",
        thumb:"https://cdn.shopify.com/s/files/1/0845/0641/products/Pants27_540x.jpg?v=1653747533"
    },
    {
        id: 38,
        product_name: "Name OF The Product",
        description: "Description",
        price: 100,
        currency: "LE",
        discount:'-25%',
        category: "Men",
        subCat:"Discount",
        classify:"Bottoms",
        colors:["red","black","crimson","teal"],
        "src": [
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/qwqfyddzikcgc4ozwigp/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/fxufamcpmcnz20lj31no/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/c90ymoqfystuna165ipq/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/dq9ivyxncfxo3gzkmlkl/revolution-5-road-running-shoes-szF7CS.png"
        ],
        content: "Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product",
        thumb:"https://cdn.shopify.com/s/files/1/0845/0641/products/Pants27_540x.jpg?v=1653747533"
    },
    {
        id: 39,
        product_name: "Name OF The Product",
        description: "Description",
        price: 100,
        currency: "LE",
        discount:'-25%',
        category: "Men",
        subCat:"Discount",
        classify:"Bottoms",
        colors:["red","black","crimson","teal"],
        "src": [
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/qwqfyddzikcgc4ozwigp/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/fxufamcpmcnz20lj31no/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/c90ymoqfystuna165ipq/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/dq9ivyxncfxo3gzkmlkl/revolution-5-road-running-shoes-szF7CS.png"
        ],
        content: "Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product",
        thumb:"https://cdn.shopify.com/s/files/1/0845/0641/products/Pants27_540x.jpg?v=1653747533"
    },
    {
        id: 40,
        product_name: "Name OF The Product",
        description: "Description",
        price: 100,
        currency: "LE",
        discount:'-25%',
        category: "Men",
        subCat:"Discount",
        classify:"Bottoms",
        colors:["red","black","crimson","teal"],
        "src": [
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/qwqfyddzikcgc4ozwigp/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/fxufamcpmcnz20lj31no/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/c90ymoqfystuna165ipq/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/dq9ivyxncfxo3gzkmlkl/revolution-5-road-running-shoes-szF7CS.png"
        ],
        content: "Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product",
        thumb:"https://cdn.shopify.com/s/files/1/0845/0641/products/Pants27_540x.jpg?v=1653747533"
    },
    {
        id: 41,
        product_name: "Name OF The Product With alot of words",
        description: "Description",
        price: 100,
        currency: "LE",
        category: "Women",
        subCat:"Featured",
        colors:["red","black","crimson","teal"],
        "src": [
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/qwqfyddzikcgc4ozwigp/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/fxufamcpmcnz20lj31no/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/c90ymoqfystuna165ipq/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/dq9ivyxncfxo3gzkmlkl/revolution-5-road-running-shoes-szF7CS.png"
        ],
        content: "Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product",
        thumb:"https://cdn.shopify.com/s/files/1/0845/0641/products/Pants27_540x.jpg?v=1653747533"
    },
    {
        id: 42,
        product_name: "Name OF The Product",
        description: "Description",
        price: 100,
        currency: "LE",
        category: "Women",
        subCat:"Featured",
        colors:["red","black","crimson","teal"],
        "src": [
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/qwqfyddzikcgc4ozwigp/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/fxufamcpmcnz20lj31no/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/c90ymoqfystuna165ipq/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/dq9ivyxncfxo3gzkmlkl/revolution-5-road-running-shoes-szF7CS.png"
        ],
        content: "Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product",
        thumb:"https://cdn.shopify.com/s/files/1/0845/0641/products/Pants27_540x.jpg?v=1653747533"
    },
    {
        id: 43,
        product_name: "Name OF The Product",
        description: "Description",
        price: 100,
        currency: "LE",
        category: "Women",
        subCat:"Featured",
        colors:["red","black","crimson","teal"],
        "src": [
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/qwqfyddzikcgc4ozwigp/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/fxufamcpmcnz20lj31no/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/c90ymoqfystuna165ipq/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/dq9ivyxncfxo3gzkmlkl/revolution-5-road-running-shoes-szF7CS.png"
        ],
        content: "Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product",
        thumb:"https://cdn.shopify.com/s/files/1/0845/0641/products/Pants27_540x.jpg?v=1653747533"
    },
    {
        id: 44,
        product_name: "Name OF The Product",
        description: "Description",
        price: 100,
        currency: "LE",
        category: "Accessories",
        subCat:"Featured",
        colors:["red","black","crimson","teal"],
        "src": [
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/qwqfyddzikcgc4ozwigp/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/fxufamcpmcnz20lj31no/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/c90ymoqfystuna165ipq/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/dq9ivyxncfxo3gzkmlkl/revolution-5-road-running-shoes-szF7CS.png"
        ],
        content: "Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product",
        thumb:"https://cdn.shopify.com/s/files/1/0845/0641/products/Pants27_540x.jpg?v=1653747533"
    },
    {
        id: 45,
        product_name: "Name OF The Product",
        description: "Description",
        price: 100,
        currency: "LE",
        category: "Men",
        subCat:"Featured",
        colors:["red","black","crimson","teal"],
        "src": [
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/qwqfyddzikcgc4ozwigp/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/fxufamcpmcnz20lj31no/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/c90ymoqfystuna165ipq/revolution-5-road-running-shoes-szF7CS.png",
            "https://static.nike.com/a/images/t_PDP_864_v1/f_auto,b_rgb:f5f5f5/dq9ivyxncfxo3gzkmlkl/revolution-5-road-running-shoes-szF7CS.png"
        ],
        content: "Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product Content of the product",
        thumb:"https://cdn.shopify.com/s/files/1/0845/0641/products/Pants27_540x.jpg?v=1653747533"
    },
]
export default product_card;